/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterItem
 */
export interface FilterItem {
    /**
     * 
     * @type {string}
     * @memberof FilterItem
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof FilterItem
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof FilterItem
     */
    count: number;
}

/**
 * Check if a given object implements the FilterItem interface.
 */
export function instanceOfFilterItem(value: object): value is FilterItem {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function FilterItemFromJSON(json: any): FilterItem {
    return FilterItemFromJSONTyped(json, false);
}

export function FilterItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterItem {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'count': json['count'],
    };
}

export function FilterItemToJSON(value?: FilterItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'key': value['key'],
        'label': value['label'],
        'count': value['count'],
    };
}

